<!--
  滑块验证码组件
-->
<template>
  <div class="slider-captcha">
    <div class="captcha-container">
      <!-- 背景图 -->
      <div
        class="captcha-bg"
        :style="{ backgroundImage: 'url(' + bgImg + ')' }"
      ></div>

      <!-- 缺口位置标记 -->
      <div
        class="gap-mask"
        :style="{
          left: gapX + 'px',
          top: gapY + 'px',
          width: blockW + 'px',
          height: blockH + 'px',
        }"
      ></div>

      <!-- 移动的图片块 -->
      <div
        class="slider-img"
        :style="{
          left: btnX + 'px',
          top: gapY + 'px',
          width: blockW + 'px',
          height: blockH + 'px',
          backgroundImage: 'url(' + bgImg + ')',
          backgroundPosition: -gapX + 'px ' + -gapY + 'px',
        }"
      ></div>
    </div>

    <!-- 滑块条 -->
    <div class="slider-bar" :class="{ success: isSuccess }">
      <div
        v-if="!isSuccess"
        class="slider-btn"
        :style="{ left: btnX + 'px' }"
        @mousedown="startDrag"
        @touchstart="startDrag"
      >
        →
      </div>
      <span class="slider-text">
        {{ isSuccess ? "验证成功" : "按住滑块拖动" }}
      </span>
    </div>

    <!-- <button class="refresh-btn" @click="refresh">刷新</button> -->
  </div>
</template>

<script>
export default {
  name: "SliderCaptcha",
  props: {
    // bgImg: { type: String, default: "https://picsum.photos/300/160" },
  },
  data() {
    return {
      isSuccess: false,
      isDragging: false,
      startX: 0,
      btnX: 0,
      bgImg: require("@/assets/image/Captcha/1.jpg"), //"https://picsum.photos/300/160",
      blockW: 40,
      blockH: 40,
      gapX: 100,
      gapY: 60,
    };
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      this.isSuccess = false;
      this.btnX = 0;
      this.gapX = 80 + Math.floor(Math.random() * 180);
      this.gapY = 20 + Math.floor(Math.random() * 100);
      // this.bgImg = "https://picsum.photos/300/160?" + Date.now();
      this.bgImg = require("@/assets/image/Captcha/" +
        this.randomNum() +
        ".jpg");
    },
    randomNum() {
      // 核心：1 ~ 80 随机整数
      return Math.floor(Math.random() * 80) + 1;
    },
    startDrag(e) {
      if (this.isSuccess) return;
      this.isDragging = true;
      this.startX = e.touches ? e.touches[0].clientX : e.clientX;
      document.addEventListener("mousemove", this.onDrag);
      document.addEventListener("mouseup", this.stopDrag);
      document.addEventListener("touchmove", this.onDrag);
      document.addEventListener("touchend", this.stopDrag);
    },

    onDrag(e) {
      if (!this.isDragging) return;
      const clientX = e.touches ? e.touches[0].clientX : e.clientX;
      let moveX = clientX - this.startX;
      if (moveX < 0) moveX = 0;
      if (moveX > 260) moveX = 260;
      this.btnX = moveX;
    },

    stopDrag() {
      this.isDragging = false;
      document.removeEventListener("mousemove", this.onDrag);
      document.removeEventListener("mouseup", this.stopDrag);
      document.removeEventListener("touchmove", this.onDrag);
      document.removeEventListener("touchend", this.stopDrag);

      const diff = Math.abs(this.btnX - this.gapX);
      if (diff < 5) {
        this.isSuccess = true;
        this.$emit("success");
      } else {
        this.btnX = 0;
      }
    },
    reset() {
      this.refresh();
    },
  },
};
</script>

<style scoped>
.slider-captcha {
  width: 300px;
  margin: 0 auto;
}

.captcha-container {
  width: 300px;
  height: 160px;
  position: relative;
  border-radius: 6px;
  overflow: hidden;
}

.captcha-bg {
  width: 300px;
  height: 160px;
  background-size: 300px 160px;
  background-repeat: no-repeat;
  position: absolute;
  top: 0;
  left: 0;
}

.gap-mask {
  position: absolute;
  background: rgba(255, 255, 255, 0.6);
  border: 1px solid #fff;
  border-radius: 4px;
  box-shadow: 0 0 8px rgba(0, 0, 0, 0.3);
}

.slider-img {
  position: absolute;
  background-size: 300px 160px;
  background-repeat: no-repeat;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.5);
  transition: left 0.03s linear;
}

.slider-bar {
  margin-top: 10px;
  width: 300px;
  height: 40px;
  background: #e0e0e0;
  border-radius: 6px;
  position: relative;
}

.slider-bar.success {
  background: #00c851;
}

.slider-btn {
  position: absolute;
  top: 0;
  width: 40px;
  height: 40px;
  background: #1976d2;
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  user-select: none;
  border-radius: 4px;
}

.slider-text {
  position: absolute;
  left: 50%;
  top: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #666;
}

.slider-bar.success .slider-text {
  color: #fff;
}

.refresh-btn {
  margin-top: 10px;
  padding: 6px 12px;
  cursor: pointer;
}
</style>
